import { tablesSelector } from '@lobby/store/selectors/tables';
import { tables } from '@lobby/store/tables';
import { isBlackjack, isUnlimitedBJ } from '@lobby/utils/functions';
import produce from 'immer';
import { of } from 'rxjs';

export const handlePlayersNumber = (socketMessage, state) => {
  const { TablesList } = socketMessage;

  const nextTables = produce(tablesSelector(state), (draftState) => {
    for (const data of TablesList) {
      const { tableId, PlayersNumber } = data;
      const table = draftState[Number(tableId)];

      if (table) {
        let playersCount = PlayersNumber;

        if (isBlackjack(table?.gameId) && !isUnlimitedBJ(table?.gameId)) {
          playersCount = table.history.filter(
            (item) => item.SeatId !== 'd' && item.Taken
          ).length;
        }

        table.playersCount = playersCount;
      }
    }
  });

  return of(
    tables.set(nextTables),
  );
};
